module.exports = __webpack_public_path__ + "img/puyang-3d8526.png";